import { render, staticRenderFns } from "./DashboardEnrollmentCurrentPlanModal.vue?vue&type=template&id=5cbbc07a"
import script from "./DashboardEnrollmentCurrentPlanModal.vue?vue&type=script&lang=js"
export * from "./DashboardEnrollmentCurrentPlanModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardEnrollmentCurrentPlanModal.vue?vue&type=style&index=0&id=5cbbc07a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports